<style type="text/css">
  .scrollit1 {
    overflow: scroll;
    height: 700px;
  }
</style>
<template>
  <div class="container register scrollit1">
    <div class="row">
      <div class="col-md-3 register-left">
        <img src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" />
        <h3>Welcome</h3>
        <p>Stream Line your Industrial Lundry Management Operations</p>
        <br />
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEmOwzLvfxnY7s_KyMRiO4o-3c9rsXdJw08f5Tqo2F_seNgzb9O58rwaHmGtIaxV5XHqc&usqp=CAU"
          alt="" />
        <p>Live results and reports of all ongoing Lundry operations</p>
      </div>
      <div class="col-md-9 register-right">
        <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
              aria-selected="true">FOXTEK</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
              aria-selected="false">B.A.O</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <h3 class="register-heading">New Organization</h3>
            <div class="row register-form">
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.company" placeholder="Company Legal Name *"
                    value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.phone" placeholder="Company Phone *" value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.country" placeholder="Country *" value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.city" placeholder="City *" value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.email" placeholder="Company Email *" value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.name" placeholder="Your Name *" value="" />
                </div>
                <div class="form-group">
                  <input type="text" v-model="org.user_email" class="form-control" placeholder="Your Email *"
                    value="" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.address" placeholder="Company Address *"
                    value="" />
                </div>
                <div class="form-group">
                  <input type="text" v-model="org.fax" class="form-control" placeholder="Fax" value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.state" placeholder="State *" value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.zipcode" placeholder="ZipCode *" value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.website" placeholder="Company Website *"
                    value="" />
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" v-model="org.designation" placeholder="Designation *"
                    value="" />
                </div>
                <div class="form-group">
                  <input type="text" v-model="org.user_name" class="form-control" placeholder="UserName *" value="" />
                </div>
                <div>
                  <input type="button" class="btnRegister1" data-dismiss="modal" value="Close" />
                  <input type="button" @click="save" class="btnRegister" value="Save" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  export default {
    data: function () {
      return {
        selected: "",
        org: this.get_empty_org_obj(),
      };
    },
    props: ["action"],
    computed: {},
    created: function () {
      this.org = this.get_empty_org_obj();
    },
    methods: {
      save() {
        if (
          this.org.user_name.replace(/\s/g, "").length &&
          this.org.company.replace(/\s/g, "").length
        ) {
    //        const permission = {
    //   headers: {
    //     'X-Permission': 'lead_create_organization' 
    //   }
    // };
    console.log('yes here organization')
          axios
            .post("/admin/users/create-organization", {
              legal_name: this.org.company,
              user_name: this.org.user_name,
              email: this.org.email,
              website: this.org.website,
              street_address: this.org.address,
              country: this.org.country,
              state: this.org.state,
              city: this.org.city,
              zipcode: this.org.zipcode,
              phone: this.org.phone,
              fax: this.org.fax,
              contact_name: this.org.name,
              contact_designation: this.org.designation,
              contact_email: this.org.user_email,
            })
            .then(() => {
              this.$store.dispatch(
                "message/update",
                {
                  title: "Organization Saved",
                  body: `Organization Save Successfully`,
                  class: "success",
                  confirm: false,
                },
                { root: true }
              );
              // this.$toast.success(`Organization Created Successfully`);
              window.$("#modal").modal("hide");
              this.org = this.get_empty_org_obj();
            })
            .catch((error) => {
              let response = error.response;
              // send error message
              this.$store.dispatch(
                "message/update",
                {
                  title: "Error",
                  body: response,
                  class: "danger",
                  confirm: false,
                },
                { root: true }
              );
            });
        } else {
          // send error message
          this.$store.dispatch(
            "message/update",
            {
              title: "Form Validation Error",
              body: "Please fill requireds fields",
              class: "danger",
              confirm: false,
            },
            { root: true }
          );
        }
      },
      get_empty_org_obj() {
        return {
          company: "",
          email: "",
          website: "",
          address: "",
          phone: "",
          fax: "",
          country: "",
          state: "",
          city: "",
          zipcode: "",
          name: "",
          designation: "",
          user_email: "",
          user_name: "",
        };
      },
    },
  };
</script>

<style>
  .register {
    background: -webkit-linear-gradient(left, #3931af, #00c6ff);
    margin-top: 3%;
    padding: 3%;
    width: 750px;
  }

  .register-left {
    text-align: center;
    color: #fff;
    margin-top: 4%;
  }

  .register-left input {
    border: none;
    border-radius: 1.5rem;
    padding: 2%;
    width: 60%;
    background: #f8f9fa;
    font-weight: bold;
    color: #383d41;
    margin-top: 30%;
    margin-bottom: 3%;
    cursor: pointer;
  }

  .register-right {
    background: #f8f9fa;
    border-top-left-radius: 10% 50%;
    border-bottom-left-radius: 10% 50%;
  }

  .register-left img {
    margin-top: 15%;
    margin-bottom: 5%;
    width: 25%;
    -webkit-animation: mover 2s infinite alternate;
    animation: mover 1s infinite alternate;
  }

  @-webkit-keyframes mover {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-20px);
    }
  }

  @keyframes mover {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-20px);
    }
  }

  .register-left p {
    font-weight: lighter;
    padding: 12%;
    margin-top: -9%;
  }

  .register .register-form {
    padding: 10%;
    margin-top: 10%;
  }

  .btnRegister {
    float: right;
    margin-top: 10%;
    border: none;
    border-radius: 1.5rem;
    padding: 2%;
    background: #0062cc;
    color: #fff;
    font-weight: 600;
    width: 50%;
    cursor: pointer;
  }

  .btnRegister1 {
    float: right;
    margin-top: 10%;
    border: none;
    border-radius: 1.5rem;
    padding: 2%;
    background: rgb(95, 95, 95);
    color: #fff;
    font-weight: 600;
    width: 50%;
    cursor: pointer;
  }

  .register .nav-tabs {
    margin-top: 3%;
    border: none;
    background: #0062cc;
    border-radius: 1.5rem;
    width: 28%;
    float: right;
  }

  .register .nav-tabs .nav-link {
    padding: 2%;
    height: 34px;
    font-weight: 600;
    color: #fff;
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .register .nav-tabs .nav-link:hover {
    border: none;
  }

  .register .nav-tabs .nav-link.active {
    width: 100px;
    color: #0062cc;
    border: 2px solid #0062cc;
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .register-heading {
    text-align: center;
    margin-top: 8%;
    margin-bottom: -15%;
    color: #495057;
  }
</style>